// DSAR register (PLAN-P3 X7) — log + track data-subject requests (GDPR Art.12/15-22) through the
// one-month deadline. Reuses the generic AggregateCrud (list + create + edit + deactivate).
import { useMutation } from "@tanstack/react-query";
import { AggregateCrud } from "../lib/aggregate-crud";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { TENANT_PATHS } from "@sympllex/api-client";
import { Button } from "@/components/ui/button";

export function DsarRoute() {
  const { t } = useI18n();
  return (
    <AggregateCrud
      title={t("page.dsar")} queryKey="dsar" basePath={TENANT_PATHS.dsar} permPrefix="data_subject_request" serverPaged
      listFn={() => api.listDsar()} createFn={(i) => api.createDsar(i as unknown as Parameters<typeof api.createDsar>[0])}
      fields={[
        { key: "requestType", label: "Type (Art.15-22)", type: "select", options: ["access", "rectification", "erasure", "restriction", "portability", "objection"], required: true },
        { key: "subjectName", label: "Data subject", type: "text", required: true },
        { key: "subjectEmail", label: "Email", type: "text" },
        { key: "status", label: "Status", type: "select", options: ["open", "in_progress", "fulfilled", "refused"] },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
      empty="No data-subject requests yet. Due date is set automatically to one month from intake (Art.12(3))."
      rowAction={(row) => <ExportPacket id={String(row.id)} />}
    />
  );
}

// PLAN-P14 X7 — open the DSAR response packet (print-friendly HTML) in a new tab.
function ExportPacket({ id }: { id: string }) {
  const dl = useMutation({
    mutationFn: async () => {
      const html = await api.exportDsarPacket(id);
      const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    },
  });
  return <Button variant="link" size="sm" className="h-auto p-0" onClick={() => dl.mutate()} disabled={dl.isPending}>{dl.isPending ? "…" : "Export"}</Button>;
}
